require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./neighborhood-enforcement-team.json") })
        }
      }, "path---neighborhood-enforcement-team");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---neighborhood-enforcement-team!./.cache/json/neighborhood-enforcement-team.json
// module id = 938
// module chunks = 231608221292675